import axiosClient from "./axiosClient";

const billTemplatesApi = {
  getAll: () => {
    return axiosClient.get("/bill_templates/get-all", {
      withCredentials: true,
    });
  },
  updateTemplate: (billTemplatePath, htmlContent) => {
    return axiosClient.put(
      "/bill_templates/update-template",
      {
        billTemplatePath,
        htmlContent,
      },
      {
        withCredentials: true,
      },
    );
  },
  getTemplate: (billTemplatePath) => {
    return axiosClient.post(
      `/bill_templates/get-template`,
      {
        billTemplatePath,
      },
      {
        withCredentials: true,
      },
    );
  },
};

export default billTemplatesApi;
